import { createChannel } from "./createChannel";

/** The types of poll messages that can be emitted. */
export const enum JupyterPollType {
  /** Just send latest data. */
  FETCH = "FETCH",
  /** React in the notebook has mounted and is ready for communications. */
  MOUNTED = "MOUNTED",
  /** React in the notebook has unmounted and will not receive communications. */
  UNMOUNTED = "UNMOUNTED",
  /** React in the notebook has rendered and is ready to be made visible. */
  RENDERED = "RENDERED",
}

// Create a type-safe iframe channel that can allow the frame to poll the parent frame (ready, etc.).
const [jupyterPollPublisher, jupyterPollSubscriber] = createChannel<
  JupyterPollType
>({
  name: "jupyter-poll-channel",
  // TODO(cochamberlain): Implement origins with definePlugin.
  publisherOrigin: "*",
  subscriberOrigin: "*",
});

export { jupyterPollPublisher, jupyterPollSubscriber };
